<template>
    <b-container v-if="$can('view-stock-transfer') || $can('view-all')" fluid>
        <b-row class="page-title">
            <b-container fluid>
                <b-row>
                    <b-col>
                        <h3>Stock Transfers</h3>
                    </b-col>
                    <b-col class="buttons-create text-right">
                        <b-button variant="outline-primary" size="sm" :to="{ name: 'StockTransferCreate' }">Create
                            Transfer</b-button>
                        <b-button variant="outline-primary" size="sm" @click="openModal('export-columns')">Export
                        </b-button>
                        <b-button variant="outline-primary" size="sm" @click="openModal('adjust-columns')"><i
                                class="fas fa-columns"></i></b-button>
                    </b-col>
                </b-row>
                <hr>
            </b-container>
        </b-row>

        <b-row>
            <b-container fluid>
                <b-row>
                    <b-col cols="3">
                        <b-form-group>
                            <b-input-group size="sm">
                                <b-form-input v-model="tables.stocktransfers.filter" type="search" id="filterInput"
                                    placeholder="Type to Search" debounce="500"></b-form-input>
                                <b-input-group-append>
                                    <b-button :disabled="!tables.stocktransfers.filter"
                                        @click="tables.stocktransfers.filter = ''">Clear</b-button>
                                </b-input-group-append>
                            </b-input-group>
                        </b-form-group>
                    </b-col>

                    <b-col cols="8" />

                    <b-col cols="1">
                        <b-form-group>
                            <b-form-select v-model="tables.stocktransfers.perPage" id="perPageSelect" size="sm"
                                :options="tables.stocktransfers.pageOptions"></b-form-select>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row class="row-stocktransfers-table">
                    <b-container fluid>
                        <b-table v-if="tables.stocktransfers.ready" :key="tables.stocktransfers.key"
                            class="stocktransfers-table" responsive bordered striped hover no-border-collapse
                            sticky-header="600px" head-variant="light" :items="tables.stocktransfers.items"
                            :fields="visibleFields" :sort-by="tables.stocktransfers.sortBy"
                            :sort-desc="tables.stocktransfers.sortDesc" :per-page="tables.stocktransfers.perPage"
                            :current-page="tables.stocktransfers.currentPage" :filter="tables.stocktransfers.filter"
                            @filtered="onFiltered" :busy="tables.stocktransfers.isBusy">

                            <template v-slot:table-busy>
                                <div class="text-center text-default my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>Loading...</strong>
                                </div>
                            </template>

                            <template v-slot:cell(reference_id)="row">
                                <b-link @click="openModal('edit-transfer', row.item.reference_id)">
                                    {{ row.item.reference_id }}
                                </b-link>
                            </template>

                                <template v-slot:cell(actions)="row">
                                    <b-container class="actions-icons" fluid>
                                        <b-row>
                                            <!-- <b-col>
                                            <b-link @click="openModal('edit-transfer', row.item)"><i
                                                    class="fas fa-edit"></i></b-link>
                                        </b-col> -->
                                            <b-col v-if="$can('view-all')">
                                                <b-link @click="deleteConfirm(row.item.reference_id)" class="icon-danger"><i class="fas fa-trash-alt"></i>
                                                </b-link>
                                            </b-col>
                                        </b-row>
                                    </b-container>
                                </template>
                        </b-table>
                    </b-container>
                </b-row>

                <b-row>
                    <b-col cols="6">
                        {{ pageTotals }}
                    </b-col>

                    <b-col cols="6" class="my-1">
                        <b-pagination v-model="tables.stocktransfers.currentPage"
                            :total-rows="tables.stocktransfers.totalRows" :per-page="tables.stocktransfers.perPage"
                            align="fill" size="sm" class="my-0"></b-pagination>
                    </b-col>
                </b-row>
            </b-container>
        </b-row>

        <modal-edit-transfer v-if="modals['edit-transfer'].active" :referenceId="modals['edit-transfer'].referenceId"
            @updateRow="getStockTransfers(1)" />

        <modal-adjust-columns v-if="modals['adjust-columns'].active" :fields="modals['adjust-columns'].fields"
            @saveColSaves="saveColSaves" />

        <modal-export-columns v-if="modals['export-columns'].active" :fields="modals['export-columns'].fields"
            :ignores="modals['export-columns'].ignores" @exportExcel="exportExcel" />
    </b-container>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import ModalEditTransfer from './modals/EditTransfer'
import ModalAdjustColumns from '../../common/modals/AdjustColumns'
import ModalExportColumns from '../../common/modals/ExportColumns'
import { mapMutations } from 'vuex'
import tableColumnPreferences from '../../../../mixins/tableColumnPreferences'
export default {
    name: 'stocktransfer',

    mixins: [tableColumnPreferences],

    metaInfo() {
        return {
            title: 'Stock Transfers',
        }
    },

    components: {
        Treeselect,
        'modal-adjust-columns': ModalAdjustColumns,
        'modal-export-columns': ModalExportColumns,
        'modal-edit-transfer': ModalEditTransfer
    },
    data() {
        return {
            modals: {
                'edit-transfer': {
                    active: 0,
                    referenceId: ''
                },

                'adjust-columns': {
                    active: 0,
                    fields: []
                },

                'export-columns': {
                    active: 0,
                    fields: [],
                    ignores: ['received_by', 'actions']
                },
            },
            tables: {
                stocktransfers: {
                    filteredItems: [],
                    isBusy: false,
                    totalRows: 1,
                    currentPage: 1,
                    perPage: 20,
                    pageOptions: [20, 50, 100, 500],
                    sortBy: 'date_completed',
                    sortDesc: true,
                    // sortDirection: 'asc',
                    filter: null,
                    filterCat: '',
                    key: 1,
                    userFields: [],
                    fields: [
                        {
                            key: 'reference_id',
                            label: 'ID',
                            sortable: true,
                            visible: 1
                        },
                        {
                            key: 'date_created',
                            label: 'Date Created',
                            sortable: true,
                            visible: 1
                        },
                        {
                            key: 'date_received',
                            label: 'Date Received',
                            sortable: true,
                            visible: 1
                        },
                        {
                            key: 'from',
                            label: 'From',
                            sortable: true,
                            visible: 1
                        },
                        {
                            key: 'to',
                            label: 'To',
                            sortable: true,
                            visible: 1
                        },
                        {
                            key: 'created_by',
                            label: 'Created By',
                            sortable: true,
                            visible: 1
                        },
                        {
                            key: 'received_by',
                            label: 'Received by',
                            sortable: true,
                            visible: 1
                        },
                        {
                            key: 'actions',
                            label: '',
                            thClass: 'stocktransfers-table-style-actions',
                            visible: 1
                        }
                    ],

                    items: [],
                    ready: 0
                },
            },

            exports: {
                cols: []
            }
        }
    },
    methods: {
        deleteConfirm(referenceId) {
            this.$bvModal.msgBoxConfirm('Please confirm that you want to delete transfer: ' + referenceId, {
                title: 'Delete Transfer: ' + referenceId,
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'danger',
                okTitle: 'Confirm',
                cancelTitle: 'Cancel',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            })
                .then(value => {
                    if (value) {
                        this.deleteTransfer(referenceId)
                    }
                })
                .catch(err => {
                    // An error occurred
                })
        },

        deleteTransfer(referenceId) {
            let url = 'api/warehousing/stocktransfer/deletetransfer/' + referenceId
            axios.get(url, {})
                .then((res) => {
                    this.showAlertBox('success', 'Transfer Deleted', 'Transfer deleted successfully!')
                    this.getStockTransfers(1)
                }, () => {
                    this.has_error = true
                })
        },

        exportExcel(cols, keys) {
            let url = 'api/exports/generateexport'
            axios.post(url, {
                rows: this.objFilter(this.tables.stocktransfers.filteredItems, keys),
                table: 'stocktransfer',
                cols: cols,
                keys: keys
            },
                {
                    responseType: 'blob'
                })
                .then((res) => {
                    this.forceFileDownload(res)
                }, () => {
                    this.has_error = true
                })
        },

        forceFileDownload(response) {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'Stock_Transfers_Export_File_' + +new Date() + '.xlsx') //or any other extension
            document.body.appendChild(link)
            link.click()

            this.showAlertBox('success', 'File Generated', 'Sales Orders export file generated successfully!')
        },

        saveState(name) {
            let page = this.tables.stocktransfers.currentPage
            let filter = this.tables.stocktransfers.filter
            let perPage = this.tables.stocktransfers.perPage
            this.setRememberStockTransfer({ name: name, page: page, filter: filter, perPage: perPage })
        },

        openModal(modalName, row, extra) {
            let prefix = 'modal-warehousing-stocktransfer-'
            switch (modalName) {
                case 'edit-transfer':
                    this.modals[modalName].active = 1
                    this.modals[modalName].referenceId = row

                    break
                case 'adjust-columns':
                    this.modals[modalName].active = 1

                    this.modals[modalName].fields = this.cloneFieldsForAdjust(this.tables.stocktransfers.userFields, this.tables.stocktransfers.fields)

                    break
                case 'export-columns':
                    this.modals[modalName].active = 1

                    this.modals[modalName].fields = JSON.parse(JSON.stringify(this.tables.stocktransfers.fields.filter(e => !this.modals[modalName].ignores.includes(e.key))))

                    break
            }

            if (modalName == 'adjust-columns' || modalName == 'export-columns') {
                prefix = 'modal-common-'
            }

            this.$nextTick(() => {
                this.$bvModal.show(prefix + modalName)
            })
        },

        toggleBusy() {
            this.tables.stocktransfers.isBusy = !this.tables.stocktransfers.isBusy
        },

        getStockTransfers(silent) {
            this.tables.stocktransfers.ready = 0
            this.tables.stocktransfers.filter = this.rememberedStockTransfer.filter
            this.tables.stocktransfers.perPage = this.rememberedStockTransfer.perPage

            if (!silent) {
                this.toggleBusy()
            }

            let url = 'api/warehousing/stocktransfer/gettransfers'
            axios.post(url, {

            })
                .then((res) => {
                    this.tables.stocktransfers.items = res.data.transfers
                    if (!this.tables.stocktransfers.filteredItems.length) {
                        this.tables.stocktransfers.filteredItems = res.data.transfers
                    }
                    this.tables.stocktransfers.totalRows = this.tables.stocktransfers.items.length
                    this.tables.stocktransfers.ready = 1

                    if (!silent) {
                        this.toggleBusy()
                    }

                    this.setLastState()
                }, () => {
                    this.has_error = true
                })
        },

        onFiltered(filteredItems) {
            this.tables.stocktransfers.totalRows = filteredItems.length
            this.tables.stocktransfers.currentPage = 1
            this.tables.stocktransfers.filteredItems = filteredItems
        },

        setLastState() {
            this.$nextTick(() => {
                if (this.rememberedStockTransfer.name && this.rememberedStockTransfer.page) {
                    this.tables.stocktransfers.currentPage = this.rememberedStockTransfer.page
                    this.$nextTick(() => {
                        this.$refs[this.rememberedStockTransfer.name].$el.scrollIntoView()
                    })
                }
            })
        },

        // ...mapMutations({
        //     setRemember: 'remembered/SET_CUSTOMER'

        // }),

        getColSaves() {
            let url = 'api/remembertable/getcolsaves/stocktransfer'
            axios.get(url, {})
                .then((res) => {
                    if (res.data.status == 'success') {
                        if (res.data.colSaves) {
                            const merged = this.mergeColSaves(this.tables.stocktransfers.fields, res.data.colSaves.column_array)
                            if (merged) {
                                this.tables.stocktransfers.userFields = merged
                            }
                        }

                        this.getStockTransfers()
                    }
                }, () => {
                    this.has_error = true
                })
        },

        saveColSaves(fields) {
            const normalized = this.normalizeColumnOrder(fields)
            this.tables.stocktransfers.userFields = normalized
            let url = 'api/remembertable/savecolsaves'
            axios.post(url, {
                area: 'stocktransfers',
                fields: this.formatColSavesPayload(normalized)
            })
                .then((res) => {
                    this.forceRerender()
                }, () => {
                    this.has_error = true
                })
        },

        forceRerender() {
            this.tables.stocktransfers.ready = 0
            let tempFields = this.tables.stocktransfers.fields
            this.tables.stocktransfers.fields = []
            this.$nextTick(() => {
                this.tables.stocktransfers.fields = tempFields
                this.tables.stocktransfers.ready = 1
            })
        }
    },

    computed: {
        sortOptions() {
            // Create an options list from our fields
            return this.tables.stocktransfers.fields
                .filter(f => f.sortable)
                .map(f => {
                    return { text: f.label, value: f.key }
                })
        },

        pageTotals() {
            let totalRows = this.tables.stocktransfers.totalRows
            let currentPage = this.tables.stocktransfers.currentPage
            let perPage = this.tables.stocktransfers.perPage

            let from
            let to

            if (perPage > totalRows) {
                from = 1
                to = totalRows
            } else {
                to = perPage * currentPage
                from = to - perPage + 1
            }

            return 'Showing ' + from + ' to ' + to + ' of ' + this.tables.stocktransfers.totalRows + ' rows'
        },

        visibleFields() {
            return this.buildVisibleFields(this.tables.stocktransfers.fields, this.tables.stocktransfers.userFields)
        }
    },

    mounted() {
        this.getColSaves()

        this.$root.$on('bv::modal::hidden', (bvEvent, modalId) => {
            switch (modalId) {
                case 'modal-common-adjust-columns':
                    this.modals['adjust-columns'].active = 0
                    this.modals['adjust-columns'].fields = []

                    break
                case 'modal-common-export-columns':
                    this.modals['export-columns'].active = 0
                    this.modals['export-columns'].fields = []

                    break
                case 'modal-warehousing-stocktransfer-edit-transfer':
                    this.modals['edit-transfer'].active = 0
                    this.modals['edit-transfer'].referenceId = []

                    break
            }
        })

        // pusher
        // Echo.channel('table-customer-updated')
        //     .listen('TableCustomerUpdated', (e) => {
        //         this.getCustomers(1)
        //     })
    }
}
</script>
<style lang="scss">
.vue-treeselect__control {
    // height: calc(1.5em + 0.5rem + 2px);
    // padding-top: 0.25rem;
    // padding-bottom: 0.25rem;
    // padding-left: 0.5rem;
    font-size: 0.875rem !important;

    .vue-treeselect__placeholder,
    .vue-treeselect__single-value {
        // line-height: 1.5
    }
}

.stocktransfers-table {
    font-size: 9pt;

    .stocktransfers-table-style-actions {
        min-width: 120px;

        .actions-icons {
            text-align: center;
            white-space: nowrap;
        }
    }

    .stocktransfers-table-style-phone {
        min-width: 105px;
    }

    .stocktransfers-table-style-th-datetime {
        min-width: 110px;
    }

    .stocktransfers-table-style-td-datetime {
        text-align: center;
    }
}
</style>
